import slice from "./overviewSlice";

export default slice.reducer;
